import PropTypes from 'prop-types';
import { useState } from 'react';

import { bookingClassNameModifier, BookingContext, bookingView } from '../../booking.context';
import { PartnerPhotoPlaceholder } from '~/components/partner-photo/partner-photo-placeholder';
import styles from '../BookingPartner.scss';

export const PartnerPhoto = ({ src = null, alt, partnerTitle }) => {
  const [imageUrl, setImageUrl] = useState(src);
  return (
    <BookingContext.Consumer>
      {(context) =>
        imageUrl ? (
          <div
            className={styles[`${bookingClassNameModifier(context)}BookingReview__partner_photo`]}
          >
            <img src={imageUrl} alt={alt} onError={() => setImageUrl(null)} />
          </div>
        ) : (
          <div
            className={styles[`${bookingClassNameModifier(context)}BookingReview__partner_empty`]}
          >
            {context === bookingView.appointment ? (
              <div>
                <p>Your</p>
                <strong>{partnerTitle}</strong>
              </div>
            ) : (
              <PartnerPhotoPlaceholder>{alt.charAt(0)}</PartnerPhotoPlaceholder>
            )}
          </div>
        )
      }
    </BookingContext.Consumer>
  );
};

PartnerPhoto.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  partnerTitle: PropTypes.string.isRequired,
};
